/**
 * Message kind → renderer registry.
 *
 * Variants can register additional kinds (e.g. 'tasting-booking',
 * 'wine-club-cta') via registry.registerMessageKind. Unknown kinds
 * are skipped silently — no break.
 */

import TextBubble from "./TextBubble.js";
import PromptList from "./PromptList.js";
import CardCarousel from "./CardCarousel.js";
import CartPanel from "../CartPanel.js";
import CartActions from "./CartActions.js";
import CheckoutOptions from "./CheckoutOptions.js";
import CheckoutForm from "./CheckoutForm.js";
import ShipAddressOptions from "./ShipAddressOptions.js";
import ShipAddressEditForm from "./ShipAddressEditForm.js";
import OrderReview from "./OrderReview.js";
import ClubWineSelection from "./ClubWineSelection.js";
import ClubOrderReview from "./ClubOrderReview.js";
import ClubCheckoutForm from "./ClubCheckoutForm.js";
import ClubConfirmation from "./ClubConfirmation.js";
import MembershipDetails from "./MembershipDetails.js";
import MembershipEditForm from "./MembershipEditForm.js";

const renderers = new Map();

renderers.set("text", TextBubble);
renderers.set("prompts", PromptList);
renderers.set("cards", CardCarousel);
renderers.set("cart", CartPanel);
renderers.set("cart-actions", CartActions);
renderers.set("checkout-options", CheckoutOptions);
renderers.set("checkout-form", CheckoutForm);
renderers.set("checkout-address-options", ShipAddressOptions);
renderers.set("checkout-address-edit-form", ShipAddressEditForm);
renderers.set("order-review", OrderReview);
// Commerce7 wine-club membership (common feature — see core/configAccessors.js
// isMembershipEnabled() for which tenants currently have it on).
renderers.set("club-wine-selection", ClubWineSelection);
renderers.set("club-order-review", ClubOrderReview);
renderers.set("club-checkout-form", ClubCheckoutForm);
renderers.set("club-confirmation", ClubConfirmation);
renderers.set("membership-details", MembershipDetails);
renderers.set("membership-edit-form", MembershipEditForm);


export function registerMessageKind(kind, RendererClass) {
  renderers.set(kind, RendererClass);
}

export function getMessageRenderer(kind) {
  return renderers.get(kind) || null;
}

export function listMessageKinds() {
  return Array.from(renderers.keys());
}
